import {Injectable, isDevMode} from '@angular/core';
import {of} from 'rxjs';

const THEME = 'gepard';
const FAVICONS_PATH = 'assets/favicon/';
const LOGOS_PATH = 'assets/img/';

@Injectable({
  providedIn: 'root',
})
export class BrandingService {
  theme$ = of(THEME);

  favicon$ = of(`${FAVICONS_PATH}favicon-${THEME}.ico`);

  logo$ = of(LOGOS_PATH + (isDevMode() ? 'logo-test.svg' : 'logo-gepard.svg'));

  logoSmall$ = of(LOGOS_PATH + (isDevMode() ? 'logo-test-small.svg' : 'logo-gepard-small.svg'));
}
